import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { WEB_URL } from '../../api/URLs';
import { GTM_EVENTS } from '../../constants';
import { MixPanelTrackedLink } from '../../components';

export default function () {
	const navigate = useNavigate();

	return (
		<React.Fragment>
			<Box className="HomeCoverBox">
				<Container className="HomeCoverContainer">
					<Stack spacing={1} className="HomeCoverStack">
						<Typography variant="h4" sx={{ fontWeight: 600 }}>
							Transform Lives Through Education
						</Typography>
						<Typography variant="h5">Fundraise for Education</Typography>
						<Typography>
							Create your personal fundraiser now and rally your friends and family. Together, we can provide quality education to children in
							Pakistan.
						</Typography>
						<Typography gutterBottom>Host a birthday bash or run a marathon – all you need is a creative idea to get started!</Typography>
						{/* <Typography variant="h4" sx={{ fontWeight: 600 }}>
							Change Begins with Education
						</Typography>
						<Typography variant="h5">This Ramadan, Fundraise for Education</Typography>
						<Typography>
							Create your personal fundraiser now and rally your friends and family. Together, we can provide quality education to children in Pakistan.
						</Typography>
						<Typography gutterBottom>Host an iftar or celebrate your child's first roza – all you need is a creative idea to get started!</Typography> */}
						<Box>
							<MixPanelTrackedLink
								gtmEvent={GTM_EVENTS.START_FUNDRAISER_CLICKED}
								onClick={() => navigate(WEB_URL.CREATE_FUNDRAISER)}
								className="StartButton"
								type="button"
								label="START YOUR FUNDRAISER"
								context="Home page"
								variant="outlined"
								size="large"
							>
								START YOUR FUNDRAISER
							</MixPanelTrackedLink>
						</Box>
					</Stack>
				</Container>
			</Box>
		</React.Fragment>
	);
}
